
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const timelineEvents = [
  {
    year: '2024.02',
    titleJa: '会社設立',
    titleEn: 'Company Founded',
    descJa: 'ビットムーブスジャパン株式会社を東京都千代田区に設立。',
  },
  {
    year: '2024',
    titleJa: 'MeVERブランド立ち上げ',
    titleEn: 'MeVER Brand Launch',
    descJa: '自社D2Cブランド「MeVER」を立ち上げ、6Dアームレストなど多機能性を備えたワークチェアを展開開始。',
  },
  {
    year: '2025.02',
    titleJa: 'Echo — DIG Shibuya 初公開',
    titleEn: 'Echo Debut at DIG Shibuya',
    descJa: 'mirariとの共同制作によるインタラクティブインスタレーション「Echo」を東京・渋谷のDIG Shibuyaにて初公開。',
  },
  {
    year: '2025',
    titleJa: '大阪・関西万博プロジェクト参画',
    titleEn: 'Expo 2025 Osaka Project',
    descJa: '2025年大阪・関西万博「カナダ館」「イタリア館」プロジェクトへ参画。',
  },
  {
    year: '2025.07',
    titleJa: 'mirari社と業務提携',
    titleEn: 'Partnership with mirari',
    descJa: 'カナダのクリエイティブスタジオmirari社と正式に業務提携を締結。',
  },
  {
    year: '2025.07',
    titleJa: 'NUMIX Award 受賞',
    titleEn: 'NUMIX Award Winner',
    descJa: 'Echoがカナダ・ケベック州の「NUMIX Award」インスタレーション部門で最優秀賞を受賞。',
  },
  {
    year: '2025.08',
    titleJa: 'Echo 法人向けレンタル開始',
    titleEn: 'Echo Rental Service Launch',
    descJa: 'Echoの法人向けレンタル提供を正式に開始。商業施設・イベント空間への導入を推進。',
  },
];

export default function CompanyTimeline() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="bg-white py-32 lg:py-40 px-8 lg:px-32">
      <div className="max-w-5xl mx-auto">
        <div
          className={`mb-20 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-4xl lg:text-5xl font-medium text-gray-900 mb-3">History</h2>
          <p className="text-base text-gray-500">沿革</p>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-[88px] top-0 bottom-0 w-px bg-gray-200 hidden lg:block" />

          <div className="space-y-0">
            {timelineEvents.map((event, index) => (
              <div
                key={index}
                className={`relative grid grid-cols-1 lg:grid-cols-[88px_1fr] gap-4 lg:gap-12 py-8 transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: isVisible ? `${index * 80 + 200}ms` : '0ms' }}
              >
                {/* Year */}
                <div className="flex items-start">
                  <p className="text-sm font-medium text-gray-900 whitespace-nowrap">{event.year}</p>
                </div>

                {/* Dot on line */}
                <div className="absolute left-[84px] top-[38px] w-[9px] h-[9px] rounded-full bg-gray-900 border-2 border-white hidden lg:block" />

                {/* Content */}
                <div className="lg:pl-8 border-b border-gray-100 pb-8">
                  <h4 className="text-base font-medium text-gray-900 mb-1">
                    <a href="#" className="hover:text-gray-600 transition-colors">{event.titleJa}</a>
                  </h4>
                  <p className="text-xs text-gray-400 mb-3">{event.titleEn}</p>
                  <p className="text-sm text-gray-600 leading-relaxed">{event.descJa}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
